import { admissionDatabaseRequests } from "@/src/api/admissionOfficeDatabaseRequests";
import { matchAuthDocByPdfPath } from "@/src/utils/admissionOffice/matchAuthDocByPdfPath";
import { parseAuthDocsResponse } from "@/src/utils/admissionOffice/parseAuthDocsResponse";

export const resolveAdmissionDocumentIdByAttachedFile = async (
  fullName: string,
  attachedFile: string,
  lookupDocumentIdByPdfPath?: (pdfPath: string) => Promise<number | null>,
): Promise<number | null> => {
  const trimmedFile = attachedFile.trim();
  const trimmedName = fullName.trim();
  if (!trimmedFile || !trimmedName) return null;

  const authRawResponse = await admissionDatabaseRequests.getAuthDocsByFullname(trimmedName);
  const authDocs = parseAuthDocsResponse(authRawResponse);
  const matchedDoc = matchAuthDocByPdfPath(authDocs, trimmedFile);
  if (typeof matchedDoc?.id === "number") {
    return matchedDoc.id;
  }

  if (lookupDocumentIdByPdfPath) {
    return lookupDocumentIdByPdfPath(trimmedFile);
  }

  return null;
};
